import { SpendTypeEnum } from '../';

export const getTextByType = (
  spendType: SpendTypeEnum,
  isRule?: boolean,
  isCreate?: boolean
) => {
  const RULE_LABEL = {
    [SpendTypeEnum.THIRD_PARTY]: 'Vendor',
    [SpendTypeEnum.PERSONNEL]: 'Personnel',
  };
  const ruleLabelLowerCase = RULE_LABEL[spendType].toLowerCase();

  return isRule
    ? {
        title: `${RULE_LABEL[spendType]} classification`,
        submit: `${isCreate ? 'Create' : 'Update'} Rule`,
        content: `Select the level 2 category to which all transactions for this ${ruleLabelLowerCase} should be assigned.\n\nYou can change the categorisation of individual transactions in the grid; the ${ruleLabelLowerCase} categorisation rule will be unaffected.`,
      }
    : {
        title: 'Transaction classification',
        submit: 'Apply',
        content: `Select the level 2 category for this transaction.\n\nThis will not affect the ${ruleLabelLowerCase} categorisation rule.`,
      };
};
